export default "__VITE_ASSET__D8A8RFVA__"